import React from 'react';
import { SoccerStats } from './types';

const SoccerStatsComponent: React.FC<{ stats: SoccerStats[] }> = ({
  stats
}) => {
  return (
    <div className='card'>
      <div className='card-body'>
        <h5 className='card-title'>Soccer Statistics</h5>
        <div className='card-text'>
          <table className='table table-bordered'>
            <tbody>
              <tr>
                <th scope='row'>Leg</th>
                {stats.map(s => (
                  <td key={s.leg}>{s.leg}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Sessions</th>
                {stats.map(s => (
                  <td key={s.leg}>{s.sessions.toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Average Score</th>
                {stats.map(s => (
                  <td key={s.leg}>{(s.averageScore || 0).toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Max Score</th>
                {stats.map(s => (
                  <td key={s.leg}>{(s.maxScore || 0).toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Kicks</th>
                {stats.map(s => (
                  <td key={s.leg}>{s.kicks.toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Min Leg Angle</th>
                {stats.map(s => (
                  <td key={s.leg}>
                    {(s.avgMinLegAngle || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Max Leg Angle</th>
                {stats.map(s => (
                  <td key={s.leg}>
                    {(s.avgMaxLegAngle || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Min Kick Distance</th>
                {stats.map(s => (
                  <td key={s.leg}>
                    {(s.avgMinFootForwardMagnitude || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Max Kick Distance</th>
                {stats.map(s => (
                  <td key={s.leg}>
                    {(s.avgMaxFootForwardMagnitude || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export { SoccerStatsComponent };
